<div class="container-fluid">
    <div class="card card-default">
        <div class="card-header">
            <h3>Reporte de Compulsas PT</h3>
        </div>
        <div class="card-body">
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-lg-12">
                        <!-- start report filters -->
                        <div class="row">
                            <div class="form-group col-lg-4 col-md-6 col-sm-12">
                                <label class="form-label">Centro de ventas</label>
                                <ceq-unit-autocomplete [listType]="'CEVE'"
                                                       (onUnitClear)="onUnitClear()"
                                                       (onUnitSelected)="onUnitSelected($event)">
                                </ceq-unit-autocomplete>
                            </div>
                           
                            <div class="form-group col-lg-2 col-md-6 col-sm-12">
                                <label class="form-label">Fecha inicial</label>
                                <input class="form-control"
                                       type="date"
                                       [(ngModel)]="startDate"
                                       max="{{ maxDate }}"
                                       (change)="onStartDateSelected()"
                                       [disabled]="working " />
                            </div>

                            <div class="form-group col-lg-2 col-md-6 col-sm-12">
                                <label class="form-label">Fecha final</label>
                                <input class="form-control"
                                       type="date"
                                       [(ngModel)]="endDate"
                                       max="{{ maxDate }}"
                                       (change)="onEndDateSelected()"
                                       [disabled]="working " />
                            </div>

                        </div>
                        <!-- end report filters -->
                        <!-- start buttons -->
                        <div class="col">
                            <div class="row">
                                <div class="form-group ">
                                    <button type="button" class="btn btn-labeled btn-outline-success mr-1 mb-2" (click)="Download()">
                                        <span class="btn-label">
                                            <i class="fa fa-file-excel-o"  style="font-size: 1.5em;" aria-hidden="true" *ngIf="!working"></i>
                                            <i class="fa fa-circle-o-notch fa-spin"  style="font-size: 1.5em;" aria-hidden="true" *ngIf="working"></i>
                                        </span>
                                        <span>Descargar reporte</span>
                                    </button>

                                </div>
                            </div>
                        </div>
                        <!-- end buttons -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>